/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationProductQuery from '../graphql/queries/GetSimulationProductQuery.js';

const useGetSimulationProductQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationProductQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationProduct: R.omit(['__typename'], data?.getSimulationProduct_simulation_product || {})
  };
};

export default useGetSimulationProductQuery;
